"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _a, _MobileStrategy_blockingInstances, _MobileStrategy_drawingToolsManager, _MobileStrategy_eventEngine, _MobileStrategy_deletionInteractionHandler, _MobileStrategy_geometryMathManager, _MobileStrategy_interactionManager, _MobileStrategy_interactionManagerHelper, _MobileStrategy_restrictionManager, _MobileStrategy_viewport, _MobileStrategy_longPressDelay, _MobileStrategy_cameraFreezeFlag, _MobileStrategy_distances, _MobileStrategy_downPress, _MobileStrategy_downPressTimeout, _MobileStrategy_hoveredPoint;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileStrategy = void 0;
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const gl_matrix_1 = require("gl-matrix");
const IDrawingToolsManager_1 = require("../../../../interfaces/IDrawingToolsManager");
class MobileStrategy {
    constructor(drawingToolsManager, interactionManager) {
        _MobileStrategy_drawingToolsManager.set(this, void 0);
        _MobileStrategy_eventEngine.set(this, viewer_shared_services_1.EventEngine.instance);
        _MobileStrategy_deletionInteractionHandler.set(this, void 0);
        _MobileStrategy_geometryMathManager.set(this, void 0);
        _MobileStrategy_interactionManager.set(this, void 0);
        _MobileStrategy_interactionManagerHelper.set(this, void 0);
        _MobileStrategy_restrictionManager.set(this, void 0);
        _MobileStrategy_viewport.set(this, void 0);
        _MobileStrategy_longPressDelay.set(this, 500);
        _MobileStrategy_cameraFreezeFlag.set(this, "");
        _MobileStrategy_distances.set(this, void 0);
        _MobileStrategy_downPress.set(this, void 0);
        _MobileStrategy_downPressTimeout.set(this, void 0);
        _MobileStrategy_hoveredPoint.set(this, undefined);
        __classPrivateFieldSet(this, _MobileStrategy_drawingToolsManager, drawingToolsManager, "f");
        __classPrivateFieldSet(this, _MobileStrategy_interactionManager, interactionManager, "f");
        __classPrivateFieldSet(this, _MobileStrategy_viewport, drawingToolsManager.viewport, "f");
        __classPrivateFieldSet(this, _MobileStrategy_geometryMathManager, __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").geometryMathManager, "f");
        __classPrivateFieldSet(this, _MobileStrategy_restrictionManager, __classPrivateFieldGet(this, _MobileStrategy_interactionManager, "f").restrictionManager, "f");
        __classPrivateFieldSet(this, _MobileStrategy_deletionInteractionHandler, __classPrivateFieldGet(this, _MobileStrategy_interactionManager, "f").deletionInteractionHandler, "f");
        __classPrivateFieldSet(this, _MobileStrategy_interactionManagerHelper, __classPrivateFieldGet(this, _MobileStrategy_interactionManager, "f").interactionManagerHelper, "f");
    }
    get cameraFreezeFlag() {
        return __classPrivateFieldGet(this, _MobileStrategy_cameraFreezeFlag, "f");
    }
    onDown(event, ray) {
        var _b, _c, _d;
        // Compute this DT's closest candidate distance (control or regular point)
        // so we can compete fairly against other DTs registered earlier.
        const controlsManager = __classPrivateFieldGet(this, _MobileStrategy_interactionManager, "f").controlsManager;
        const controlDist = (_b = controlsManager === null || controlsManager === void 0 ? void 0 : controlsManager.closestControlDistance(ray)) !== null && _b !== void 0 ? _b : Infinity;
        const pointDists = __classPrivateFieldGet(this, _MobileStrategy_geometryMathManager, "f").checkPointDistances(ray, __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").positionArray);
        const pointDist = (_d = (_c = pointDists === null || pointDists === void 0 ? void 0 : pointDists[0]) === null || _c === void 0 ? void 0 : _c.distance) !== null && _d !== void 0 ? _d : Infinity;
        const myClosestDist = Math.min(controlDist, pointDist);
        // Cross-DT priority: compete against any earlier DT that has registered a
        // control-drag claim.  If we are closer we cancel their weaker claim; if
        // they are closer (or equal) we are outbid and skip this DT entirely.
        // When this DT has nothing close (myClosestDist = Infinity) but another DT
        // does, skip to avoid spurious long-press at the same location.
        if (myClosestDist < Infinity) {
            const toCancel = [];
            let wasOutbid = false;
            for (const entry of __classPrivateFieldGet(_a, _a, "f", _MobileStrategy_blockingInstances).values()) {
                if (myClosestDist < entry.distance) {
                    toCancel.push(entry.cancel);
                }
                else {
                    wasOutbid = true;
                }
            }
            if (wasOutbid)
                return;
            for (const cancel of toCancel)
                cancel();
        }
        else if (__classPrivateFieldGet(_a, _a, "f", _MobileStrategy_blockingInstances).size > 0) {
            // Nothing close on this DT but another DT has a valid hit — skip.
            return;
        }
        __classPrivateFieldSet(this, _MobileStrategy_downPress, { event, ray }, "f");
        // Try edge-control drag first, but only if the control is at least as
        // close as this DT's own regular points.
        if (controlDist < Infinity &&
            controlDist <= pointDist &&
            controlsManager.checkHover(ray) &&
            controlsManager.startDragging()) {
            const uuid = __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").uuid;
            __classPrivateFieldGet(_a, _a, "f", _MobileStrategy_blockingInstances).set(uuid, {
                distance: controlDist,
                cancel: () => {
                    var _b;
                    (_b = __classPrivateFieldGet(this, _MobileStrategy_interactionManager, "f").controlsManager) === null || _b === void 0 ? void 0 : _b.onOut();
                    this.clearDownPress();
                },
            });
            if (!__classPrivateFieldGet(this, _MobileStrategy_cameraFreezeFlag, "f"))
                __classPrivateFieldSet(this, _MobileStrategy_cameraFreezeFlag, __classPrivateFieldGet(this, _MobileStrategy_viewport, "f").addFlag(viewer_shared_types_1.FLAG_TYPE.CAMERA_FREEZE), "f");
            return;
        }
        // Reuse the already-computed point distances.
        __classPrivateFieldSet(this, _MobileStrategy_distances, pointDists, "f");
        if (__classPrivateFieldGet(this, _MobileStrategy_distances, "f") && __classPrivateFieldGet(this, _MobileStrategy_distances, "f").length > 0) {
            // Register this point hit as a blocking claim so that other DTs
            // processed later in the same touch event are outbid when their
            // nearest candidate is farther away.
            const uuid = __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").uuid;
            __classPrivateFieldGet(_a, _a, "f", _MobileStrategy_blockingInstances).set(uuid, {
                distance: pointDist,
                cancel: () => {
                    __classPrivateFieldGet(this, _MobileStrategy_interactionManagerHelper, "f").removeAllSelectedPoints();
                    this.clearDownPress();
                },
            });
            // select the point
            if (__classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").settings.general.enableSelection)
                __classPrivateFieldGet(this, _MobileStrategy_interactionManagerHelper, "f").toggleSelection(__classPrivateFieldGet(this, _MobileStrategy_distances, "f")[0].index);
            __classPrivateFieldGet(this, _MobileStrategy_interactionManagerHelper, "f").hoveredPoint =
                __classPrivateFieldGet(this, _MobileStrategy_distances, "f")[0].index;
            const draggingStarted = __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").settings.general.enableTranslation &&
                __classPrivateFieldGet(this, _MobileStrategy_interactionManagerHelper, "f").startDragging();
            __classPrivateFieldGet(this, _MobileStrategy_interactionManagerHelper, "f").moving = !!draggingStarted;
            // we remove this here, because on mobile there is actually no hovering
            __classPrivateFieldGet(this, _MobileStrategy_interactionManagerHelper, "f").hoveredPoint = undefined;
            __classPrivateFieldSet(this, _MobileStrategy_hoveredPoint, __classPrivateFieldGet(this, _MobileStrategy_distances, "f")[0].index, "f");
            if (draggingStarted && !__classPrivateFieldGet(this, _MobileStrategy_cameraFreezeFlag, "f"))
                __classPrivateFieldSet(this, _MobileStrategy_cameraFreezeFlag, __classPrivateFieldGet(this, _MobileStrategy_viewport, "f").addFlag(viewer_shared_types_1.FLAG_TYPE.CAMERA_FREEZE), "f");
        }
        __classPrivateFieldSet(this, _MobileStrategy_downPressTimeout, setTimeout(() => {
            // it's a long press!
            // do long press stuff here
            if (__classPrivateFieldGet(this, _MobileStrategy_distances, "f") && __classPrivateFieldGet(this, _MobileStrategy_distances, "f").length > 0) {
                // remove the point
                if (__classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").settings.general.enableDeletion)
                    __classPrivateFieldGet(this, _MobileStrategy_deletionInteractionHandler, "f").deletePoint(ray);
            }
            else {
                // check if there is a midpoint close to the ray
                if (__classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").settings.general
                    .enableInsertion &&
                    __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").geometryState.canAddPoint()) {
                    // check if there is a line close to the ray and add a mid point to it
                    const lineDistances = __classPrivateFieldGet(this, _MobileStrategy_geometryMathManager, "f").checkLineDistances(ray, __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").positionArray, __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").indicesArrayLines);
                    if (lineDistances) {
                        let firstIndex = lineDistances[0].index[0];
                        let secondIndex = lineDistances[0].index[1];
                        const firstPoint = __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").geometryState.getPosition(firstIndex);
                        const secondPoint = __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").geometryState.getPosition(secondIndex);
                        const midPoint = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), firstPoint, secondPoint);
                        gl_matrix_1.vec3.scale(midPoint, midPoint, 0.5);
                        __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").addPoint(secondIndex, midPoint);
                    }
                }
            }
            // cleanup
            this.clearDownPress();
        }, __classPrivateFieldGet(this, _MobileStrategy_longPressDelay, "f")), "f");
    }
    onKeyDown() { }
    onMove(event, ray) {
        const distanceSquared = __classPrivateFieldGet(this, _MobileStrategy_downPress, "f")
            ? Math.pow(event.clientX - __classPrivateFieldGet(this, _MobileStrategy_downPress, "f").event.clientX, 2) +
                Math.pow(event.clientY - __classPrivateFieldGet(this, _MobileStrategy_downPress, "f").event.clientY, 2)
            : Infinity;
        const clickThresholdSquared = 25;
        const pointerMoved = distanceSquared > clickThresholdSquared;
        // If an edge control is being dragged, move it.
        const controlsManager = __classPrivateFieldGet(this, _MobileStrategy_interactionManager, "f").controlsManager;
        if (controlsManager === null || controlsManager === void 0 ? void 0 : controlsManager.isDraggingControl) {
            if (pointerMoved) {
                controlsManager.moveDraggedControl(ray);
                if (__classPrivateFieldGet(this, _MobileStrategy_downPressTimeout, "f")) {
                    clearTimeout(__classPrivateFieldGet(this, _MobileStrategy_downPressTimeout, "f"));
                    __classPrivateFieldSet(this, _MobileStrategy_downPressTimeout, undefined, "f");
                }
            }
            return;
        }
        // if we have selected points, move them
        if (__classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").settings.general.enableTranslation &&
            __classPrivateFieldGet(this, _MobileStrategy_interactionManagerHelper, "f").selectedPointIndices.length > 0 &&
            pointerMoved === true) {
            __classPrivateFieldGet(this, _MobileStrategy_interactionManagerHelper, "f").hoveredPoint = __classPrivateFieldGet(this, _MobileStrategy_hoveredPoint, "f");
            // get the restricted point
            const restrictedPoint = __classPrivateFieldGet(this, _MobileStrategy_interactionManagerHelper, "f").moveSelectedPoints(ray);
            __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").textVisualizationManager.updatePointerPosition(restrictedPoint);
            if (__classPrivateFieldGet(this, _MobileStrategy_downPressTimeout, "f")) {
                clearTimeout(__classPrivateFieldGet(this, _MobileStrategy_downPressTimeout, "f"));
                __classPrivateFieldSet(this, _MobileStrategy_downPressTimeout, undefined, "f");
            }
        }
        else if (__classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").settings.general.enableInsertion &&
            __classPrivateFieldGet(this, _MobileStrategy_interactionManagerHelper, "f").selectedPointIndices.length === 0) {
            // No point being dragged — show where a new point would be inserted
            const rayTraceResult = __classPrivateFieldGet(this, _MobileStrategy_restrictionManager, "f").rayTrace(ray, {
                type: "drawing",
                positionArray: __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").positionArray,
            });
            __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").textVisualizationManager.updatePointerPosition(rayTraceResult === null || rayTraceResult === void 0 ? void 0 : rayTraceResult.point);
        }
    }
    onOut() {
        var _b;
        // Cancel any in-progress edge control drag.
        (_b = __classPrivateFieldGet(this, _MobileStrategy_interactionManager, "f").controlsManager) === null || _b === void 0 ? void 0 : _b.onOut();
        // cleanup
        __classPrivateFieldGet(this, _MobileStrategy_interactionManagerHelper, "f").removeAllSelectedPoints();
        __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").textVisualizationManager.updatePointerPosition(undefined);
        this.clearDownPress();
    }
    onUp(event) {
        // If an edge control was being dragged, commit it.
        const controlsManager = __classPrivateFieldGet(this, _MobileStrategy_interactionManager, "f").controlsManager;
        if (controlsManager === null || controlsManager === void 0 ? void 0 : controlsManager.isDraggingControl) {
            controlsManager.endDragging();
            this.clearDownPress();
            return;
        }
        if (__classPrivateFieldGet(this, _MobileStrategy_downPressTimeout, "f")) {
            // it's a short press!
            // do short press stuff here
            // check if we pressed on an existing point
            if (__classPrivateFieldGet(this, _MobileStrategy_distances, "f") && __classPrivateFieldGet(this, _MobileStrategy_distances, "f").length > 0) {
                const canBeClosed = __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").settings.geometry.mode ===
                    "lines" &&
                    __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").geometryState.getPointCount() >=
                        3 &&
                    __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").geometryState.checkNumberOfPoints(__classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").geometryState.getPointCount());
                const shouldBeClosed = __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").settings.geometry.close ===
                    true &&
                    __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").geometryState.closeLoop ===
                        false &&
                    __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").settings.geometry.autoClose ===
                        false;
                // check if we pressed on the first point and if we can close the geometry
                if (__classPrivateFieldGet(this, _MobileStrategy_distances, "f")[0].index === 0 &&
                    canBeClosed &&
                    shouldBeClosed) {
                    // close the geometry
                    __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").geometryState.closeLoop = true;
                    __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").updateMaterialIndex(0, IDrawingToolsManager_1.MATERIAL_INDEX.DEFAULT);
                    __classPrivateFieldGet(this, _MobileStrategy_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.GEOMETRY_CHANGED, {
                        viewportId: __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").viewport.id,
                        drawingToolsId: __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").uuid,
                        points: __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").geometryState.getPointsData(),
                        metaData: __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").geometryState
                            .metadataArray,
                        temporary: false,
                        fromHistory: false,
                    });
                    // When autoUpdate is false the GEOMETRY_CHANGED listener is
                    // gated and will not call update(), so we mirror desktop
                    // behavior and call it directly.
                    if (!__classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").settings.general.autoUpdate) {
                        __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").update();
                    }
                }
            }
            else {
                if (!__classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").settings.general.enableInsertion)
                    return;
                // get current ray
                const ray = __classPrivateFieldGet(this, _MobileStrategy_viewport, "f").pointerEventToRay(__classPrivateFieldGet(this, _MobileStrategy_downPress, "f").event);
                // add a point at the ray intersection
                const rayTraceResult = __classPrivateFieldGet(this, _MobileStrategy_restrictionManager, "f").rayTrace(ray, {
                    type: "drawing",
                    positionArray: __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").positionArray,
                });
                const restrictedPoint = rayTraceResult === null || rayTraceResult === void 0 ? void 0 : rayTraceResult.point;
                const insertionIndex = __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").geometryState.getPointCount();
                __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").addPoint(insertionIndex, restrictedPoint, rayTraceResult);
                // If the maximum number of points has been reached, call
                // update() directly, mirroring desktop behavior. We only
                // skip the direct call when the GEOMETRY_CHANGED listener
                // would already fire update() (autoUpdate on AND the close
                // state condition passes), to avoid calling it twice.
                const dtSettings = __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").settings;
                const dtGeometryState = __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").geometryState;
                const reachedMax = dtSettings.geometry.maxPoints !== undefined &&
                    dtGeometryState.getPointCount() ===
                        dtSettings.geometry.maxPoints;
                if (reachedMax) {
                    const listenerWillFire = dtSettings.general.autoUpdate &&
                        (dtSettings.geometry.autoClose ||
                            dtSettings.geometry.close ===
                                dtGeometryState.closeLoop);
                    if (!listenerWillFire) {
                        __classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").update();
                    }
                }
            }
        }
        else {
            __classPrivateFieldGet(this, _MobileStrategy_interactionManagerHelper, "f").hoveredPoint = undefined;
            __classPrivateFieldGet(this, _MobileStrategy_interactionManagerHelper, "f").onUp();
        }
        // cleanup
        this.clearDownPress();
    }
    clearDownPress() {
        if (__classPrivateFieldGet(this, _MobileStrategy_cameraFreezeFlag, "f")) {
            __classPrivateFieldGet(this, _MobileStrategy_viewport, "f").removeFlag(__classPrivateFieldGet(this, _MobileStrategy_cameraFreezeFlag, "f"));
            __classPrivateFieldSet(this, _MobileStrategy_cameraFreezeFlag, "", "f");
        }
        __classPrivateFieldGet(_a, _a, "f", _MobileStrategy_blockingInstances).delete(__classPrivateFieldGet(this, _MobileStrategy_drawingToolsManager, "f").uuid);
        __classPrivateFieldSet(this, _MobileStrategy_hoveredPoint, undefined, "f");
        __classPrivateFieldGet(this, _MobileStrategy_restrictionManager, "f").showRestrictionVisualization = false;
        __classPrivateFieldGet(this, _MobileStrategy_interactionManagerHelper, "f").reset();
        __classPrivateFieldSet(this, _MobileStrategy_distances, undefined, "f");
        __classPrivateFieldSet(this, _MobileStrategy_downPress, undefined, "f");
        if (__classPrivateFieldGet(this, _MobileStrategy_downPressTimeout, "f")) {
            clearTimeout(__classPrivateFieldGet(this, _MobileStrategy_downPressTimeout, "f"));
            __classPrivateFieldSet(this, _MobileStrategy_downPressTimeout, undefined, "f");
        }
    }
}
exports.MobileStrategy = MobileStrategy;
_a = MobileStrategy, _MobileStrategy_drawingToolsManager = new WeakMap(), _MobileStrategy_eventEngine = new WeakMap(), _MobileStrategy_deletionInteractionHandler = new WeakMap(), _MobileStrategy_geometryMathManager = new WeakMap(), _MobileStrategy_interactionManager = new WeakMap(), _MobileStrategy_interactionManagerHelper = new WeakMap(), _MobileStrategy_restrictionManager = new WeakMap(), _MobileStrategy_viewport = new WeakMap(), _MobileStrategy_longPressDelay = new WeakMap(), _MobileStrategy_cameraFreezeFlag = new WeakMap(), _MobileStrategy_distances = new WeakMap(), _MobileStrategy_downPress = new WeakMap(), _MobileStrategy_downPressTimeout = new WeakMap(), _MobileStrategy_hoveredPoint = new WeakMap();
// Maps uuid → {distance, cancel} for any DT that has started a control drag
// on the current touch. A later DT compares its own closest distance; if it
// is closer it cancels the earlier claim and takes over, so the globally
// nearest target always wins.
_MobileStrategy_blockingInstances = { value: new Map() };
//# sourceMappingURL=MobileStategy.js.map